import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';
import { SoleBusiness } from 'taxtank-core';

@Component({
  selector: 'app-sole-business-form-dialog',
  templateUrl: './sole-business-form-dialog.component.html',
  styleUrls: ['./sole-business-form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SoleBusinessFormDialogComponent {
  dialogRef = inject(MatDialogRef<SoleBusinessFormDialogComponent>);
  business: SoleBusiness = inject(MAT_DIALOG_DATA);
}
